import {Sensor} from "../../../../api/sensor";
import {WithAPI} from "../../../../api/temperature";
import {useFetchAndRender} from "../../../fetchAndRender";
import {useAlert} from "../../../generic/alert";
import {Dialog, DialogClose, DialogContent, DialogOptions} from "../../../generic/dialog";
import {Card} from "../../../generic/card";
import {FormFooter, FormGroup} from "../../../generic/form";
import {Button} from "../../../generic/button";
import {useAccent} from "../../../../theme/accents";
import {useFlash} from "../../../generic/flash";

export type MergeSensorDialogProps = {
    sensor: Sensor;
} & WithAPI & DialogOptions;

export function MergeSensorDialog({api, sensor, ...props}: MergeSensorDialogProps) {
    const [sensors] = useFetchAndRender(async () => {
        return (await api.sensor.get({
            attributes: ["id", "name"],
            filter: {
                active: undefined
            }
        })).sensors.filter(s => s.id !== sensor.id);
    }, {interval: 0});

    const {showAlert, showConfirm} = useAlert();
    const {success} = useFlash();

    if (sensors === undefined) {
        return null;
    }

    if (sensors.length === 0) {
        showAlert("Unable to merge", "There are no other sensors that this one could be merged into.");
        return null;
    }

    return <Dialog {...props}>
        <DialogContent>
            <Card title={`Merge sensor ${sensor.name} into...`}>
                <form onSubmit={(e) => {
                    e.preventDefault();

                    const fd = new FormData(e.currentTarget);
                    showConfirm("Proceed with merge?", `Do you want to merge sensor ${sensor.name} into ${sensors.find(s => s.id === Number.parseInt(fd.get("target") as string))?.name}?`).then(r => {
                        if (r === "yes") {
                            api.sensor.merge(sensor, Number.parseInt(fd.get("target") as string))
                                .then(() => {
                                    success(`Sensors ${sensor.name} and ${sensors.find(s => s.id === Number.parseInt(fd.get("target") as string))?.name} has been merged.`);
                                    props.onOpenChange(false)
                                })
                                .catch(e => showAlert("Merging failed", `Merging of sensors failed: ${e}`));
                        }
                    })
                }}>
                    <p>By merging sensors, data from sensor {sensor.name} will be merged into selected sensor. Original sensor will be removed. It another reading is received for the original sensor, it will be recreated.</p>

                    <FormGroup>
                        <label for="input--target-sensor">Select target sensor:</label>
                        <select id="input--target-sensor" name="target">
                            {sensors.map(s => <option value={s.id}>{s.name}</option>)}
                        </select>
                    </FormGroup>

                    <FormFooter>
                        <Button type="submit">Merge!</Button>
                        <DialogClose>Cancel</DialogClose>
                    </FormFooter>
                </form>
            </Card>
        </DialogContent>
    </Dialog>;
}
